import { Box, Button, Card, Flex, Heading, Link, Text } from '@asktia/tia-ui'
import { FC } from 'react'
import { useAmpli, useNavigation } from 'src/hooks'
import { Intervention, Partner } from 'src/types'

import CompanyWith from 'src/pages/YourCare/CompanyWith'

export const CarePlanItem: FC<Intervention> = props => {
    const partner: Partner | undefined = props.partner
    const hasFollowUpUrl = partner && Boolean(partner.followUpUrl)
    const { navigateOutsideRouter } = useNavigation()
    const { carePlanIntervention } = props
    const { partnerCtaClicked } = useAmpli()

    return (
        <Card>
            <Flex
                sx={{
                    width: '100%',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Flex sx={{ flexDirection: 'column', width: '100%' }}>
                    <Flex
                        sx={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            gap: '8px',
                            width: '100%'
                        }}
                    >
                        <Box>
                            <Heading h4>{props.partner?.displayName} </Heading>
                        </Box>
                        {props.partner && (
                            <CompanyWith partner={props.partner}></CompanyWith>
                        )}
                    </Flex>
                    {carePlanIntervention?.patientEducation && (
                        <Card
                            variant="info"
                            sx={{
                                mb: 2,
                                mt: 4,
                                padding: 2,
                                minWidth: '100%',
                                background: 'cream',
                                border: '1px solid',
                                borderColor: 'oat'
                            }}
                        >
                            <Text variant="supportingInfo">
                                Notes from your provider:
                            </Text>
                            <Text
                                variant="supportingInfo"
                                sx={{
                                    'display': '-webkit-box',
                                    'mt': 2,
                                    'overflow': 'hidden',
                                    '-webkit-line-clamp': '2',
                                    '-webkit-box-orient': 'vertical'
                                }}
                            >
                                {carePlanIntervention.patientEducation}
                            </Text>
                        </Card>
                    )}
                </Flex>
            </Flex>
            <Flex sx={{ justifyContent: 'space-between' }}>
                {/* we show a read more button if this partner will also have a 
                follow up otherwise there is one button but alwasy saying next steps */}
                {hasFollowUpUrl && (
                    <>
                        <Button
                            mt="4"
                            as={Link}
                            href={`/r/your-care/plan/${carePlanIntervention.uuid}`}
                            variant="secondaryDark"
                            sx={{
                                mr: '16px'
                            }}
                        >
                            Read More
                        </Button>
                        <Button
                            mt="4"
                            sx={{
                                backgroundColor: 'tiaPink'
                            }}
                            onClick={() => {
                                partnerCtaClicked({
                                    name: partner.name,
                                    type: partner.type
                                })
                                navigateOutsideRouter(
                                    // @ts-ignore
                                    partner.followUpUrl,
                                    partner?.name || '_blank'
                                )
                            }}
                        >
                            {partner.followUpCta || 'next steps'}
                        </Button>{' '}
                    </>
                )}

                {!hasFollowUpUrl && (
                    <>
                        <Button
                            mt="4"
                            fullWidth
                            as={Link}
                            href={`/r/your-care/plan/${carePlanIntervention.uuid}`}
                            sx={{
                                backgroundColor: 'tiaPink'
                            }}
                        >
                            Next steps
                        </Button>
                    </>
                )}
            </Flex>
        </Card>
    )
}
